import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import cn from 'classnames';
import { Modal } from './Modal';
import { ModalClose } from './ModalClose';
import Drawer from '../../ui-components/Drawer/Drawer';
import Typography, {
  TypographyVariants,
  TypographyWeights,
} from '../../ui-components/Typography/Typography';
import SocialLoginButtons from '../SocialLoginButtons/SocialLoginButtons';
import {
  action_closeModalLikeListing,
  selector_isOpenModalLikeListing,
} from '../data/isOpenModalLikeListing';
import { useAuth0 } from '../../context/auth0';
import { useMatchesMinWidth } from '../../hooks/useMatchesMinWidth';
import { BREAKPOINTS } from '../../../constants';

const ModalLikeListing = () => {
  const isOpenModalLikeListing = useSelector(selector_isOpenModalLikeListing);
  const dispatch = useDispatch();
  const { loginWithRedirect } = useAuth0();
  const isDesktop = useMatchesMinWidth(BREAKPOINTS.TABLET_LANDSCAPE);
  const close = () => dispatch(action_closeModalLikeListing());

  // app_main_wpml is the wp_localize_script global (functions.php); read directly like the other modals, despite the lint errors.
  const title = (
    <Typography variant={TypographyVariants.h6} weight={TypographyWeights.bold}>
      {app_main_wpml.login_or_register}
    </Typography>
  );

  // On desktop the title is part of the card; the drawer shows it in its header.
  const content = (
    <div
      className={cn('modal-like-listing', {
        'modal-like-listing--drawer': !isDesktop,
      })}
    >
      {isDesktop && title}
      <Typography
        variant={TypographyVariants.p2}
        classNames="modal-like-listing__text"
      >
        {/* app_main_wpml is the wp_localize_script global (functions.php); read directly like the other modals, despite the lint errors. */}
        {app_main_wpml.register_favourite}
      </Typography>
      <SocialLoginButtons />
      <button
        type="button"
        onClick={loginWithRedirect}
        className="modal-like-listing__email"
      >
        {/* app_main_wpml is the wp_localize_script global (functions.php); read directly like the other modals, despite the lint errors. */}
        {app_main_wpml.continue_with_email}
      </button>
    </div>
  );

  if (!isDesktop) {
    return (
      <Drawer
        classNames="drawer--content-start"
        isOpen={isOpenModalLikeListing}
        onClose={close}
        title={title}
        body={content}
      />
    );
  }

  return (
    <Modal
      onClickOverlay={close}
      isOpen={isOpenModalLikeListing}
      shouldScroll={false}
      modalCustomWidth={560}
    >
      {content}
      {/* After the content: .modal-like-listing is position: relative and would paint over the X. */}
      <ModalClose onClick={close} />
    </Modal>
  );
};

export { ModalLikeListing };
